import { render, staticRenderFns } from "./NetIncomeKPM.vue?vue&type=template&id=57d6bebd"
import script from "./NetIncomeKPM.vue?vue&type=script&lang=js"
export * from "./NetIncomeKPM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57d6bebd')) {
      api.createRecord('57d6bebd', component.options)
    } else {
      api.reload('57d6bebd', component.options)
    }
    module.hot.accept("./NetIncomeKPM.vue?vue&type=template&id=57d6bebd", function () {
      api.rerender('57d6bebd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/reports/NetIncomeKPM.vue"
export default component.exports